import { Typography } from '@altibox/lte-salgskanaler-design-system-component-lib';
import { styled } from 'styled-components';

import { Checkbox } from 'src/components/checkbox';
import { Image } from 'src/components/image';
import { breakpointTablet } from 'src/styles/breakpoints';
import { colorNeutral, colorSecondary200 } from 'src/styles/colors';
import { spacing2, spacing3, spacing5 } from 'src/styles/spacing';

export const StyledCheckbox = styled(Checkbox)`
  border: 1px solid ${colorSecondary200};
  box-sizing: border-box;
  box-shadow: 0 4px 4px rgb(0 0 0 / 25%);
  border-radius: 8px;
  padding: ${spacing2};
  background-color: ${colorNeutral};
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (min-width: ${breakpointTablet}) {
    padding: ${spacing3} ${spacing5} ${spacing3} ${spacing3};
  }

  &:hover {
    background: ${colorSecondary200};
  }

  &:not(:last-child) {
    margin-bottom: ${spacing2};
  }
`;

export const StyledMacText = styled(Typography)`
  font-weight: bold;
  flex-grow: 1;
`;

export const StyledImage = styled(Image)`
  margin-right: ${spacing3};
  max-height: 31px;
`;
